import { AlertTriangle } from "lucide-react";

import { Button } from "components/ui/button";

interface ErrorStateProps {
  onRetry: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-10 border border-destructive/30 bg-destructive/5 rounded-lg">
      <AlertTriangle className="h-8 w-8 text-destructive" />
      <p className="text-sm text-destructive font-medium">
        Erro ao carregar os meses fiscais
      </p>
      <Button variant="outline" onClick={onRetry}>
        Tentar novamente
      </Button>
    </div>
  );
}
